import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiHumanResources from "./../../assets/images/banner/ai-hr.png";
import { Link, useLocation } from "react-router-dom";

const AI_Human_Resources = () => {
  pageTitle("RPA in Human Resources");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here

    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "AI_Accounting_Finance", slug: "/AI_Accounting_Finance" },
    { id: 2, title: "AI-Audit-Compliance", slug: "/AI-Audit-Compliance" },
    { id: 3, title: "AI-Human-Resources", slug: "/AI-Human-Resources" },
    { id: 4, title: "AI-Operations", slug: "/AI-Operations" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <HeaderOne></HeaderOne>
<div className="ai-overlay-wrapper">
  <img
    src={aiHumanResources}
    alt="AI Operations"
    className="img-fluid"
  />

  <div className="ai-overlay">
    <h2>AI Human Resources</h2>
  </div>
</div>
      {/* RPA Accounting Impact Section */}
      <section className="rpa-af-section">
        <div className="container">
          {/* FULL WIDTH INTRO */}
          <div className="row">
            <div className="col-12">
              <div className="rpa-af-content">
                <h2 className="rpa-af-title">
                  RPA for Human Resources and Administration Processes
                </h2>

                <p className="rpa-af-desc">
                  <span className="rpa-af-dropcap">H</span>
                  uman Resources{" "}
                  <span className="rpa-af-highlight">
                     Human Resources 
                  </span>{" "}
                 (HR) and administrative duties are full of repetitive processes that department workers spend significant time on. Consequently, these individuals are often the face of the organization, especially for new hires joining the company. Freeing this department of mundane tasks through RPA can create an environment of people-facing innovation, keeping the organization’s front line engaged where they’re needed most.
                </p>
              </div>
            </div>
          </div>

          {/* TWO COLUMN SECTION */}
          <div className="row align-items-center mt-4">
            {/* LEFT CONTENT */}
            <div className="col-lg-8">
              <h3 className="rpa-af-subtitle">What’s the Impact?</h3>

              <p className="rpa-af-desc">
                With nearly half of Human Resources and administrative tasking being repetitive, HR is becoming less and less “human”. These individuals need to be focused on people rather than processing piles of documents, especially being the front-liners for onboarding new team members to the organization, encompassing even more repetitive tasks.
              </p>
              <p className="rpa-af-desc mt-3">
               HR departments globally are implementing RPA technology into their repetitive, paperwork-driven processes, rendering these individuals much more valuable to new and existing staff. These departments are witnessing significantly faster employee onboarding through RPA, and this freeing them from administrative tasks and allowing more time for talent acquisition.
              </p>
            </div>

            {/* RIGHT CARD */}
            <div className="col-lg-4">
              <div className="rpa-af-stats-card">
                <div className="rpa-af-stats-row">
                  <div className="rpa-af-stat">

                    <div>
                      <h4>40%</h4>
                    </div>
                  </div>

                </div>

                <p className="rpa-af-case-text">
                  of tasks performed in the Human Resources department are repetitive and redundant, limiting time for strategic tasks.
                </p>

                
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RPA Use Cases Section */}
      <section className="rpa-uc-section">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT GRADIENT CARD */}
            <div className="col-lg-4">
              <div className="rpa-uc-card">
               <div className="rpa-uc-card-icon">
  <i class="fa-solid fa-user-gear"></i> 
</div>


                <h3 className="rpa-uc-card-title">
                  Digitizing Human Resources Operations
                 
                </h3>

                <ul className="rpa-uc-card-list">
                  <li>Strengthen employee relationships</li>
                  <li>Enhance recruitment efforts</li>
                  <li>Eliminate human error</li>
                  <li>People over paperwork</li>
                </ul>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8">
              <div className="rpa-uc-content">
                <h2 className="rpa-uc-heading">
                  RPA Use Cases for Human Resources
                </h2>

                <ul className="rpa-uc-list">
                  <li>
             
                      <strong>Recruiting:</strong> Spend less time sourcing and assessing candidates and more time meeting/engaging them in person.
              
                  </li>

                  <li>
                    
                      <strong>Internal Focus:</strong> HR departments can spend time conducting internal training, and strengthening unique initiatives in the business.
                   
                  </li>

                  <li>
             
                      <strong>Stronger Employee Relations:</strong> Develop and nurture programs that prevent employee incidents, and strengthen overall moral in the process.
              
                  </li>

                  <li>
             
                      <strong>Enhance Onboarding Efforts:</strong> Reduce employee turnover by spending less time on paperwork and more on the humans joining the team.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_Human_Resources;
